import { useState } from "react";
import { useTranslation } from "react-i18next";

const faqItems = [
  { q: "faq.1.q", a: "faq.1.a" },
  { q: "faq.2.q", a: "faq.2.a" },
  { q: "faq.3.q", a: "faq.3.a" },
  { q: "faq.4.q", a: "faq.4.a" },
  { q: "faq.5.q", a: "faq.5.a" },
  { q: "faq.6.q", a: "faq.6.a" },
  { q: "faq.7.q", a: "faq.7.a" },
  { q: "faq.8.q", a: "faq.8.a" },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("faq.subtitle")}
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-semibold text-foreground-900 md:text-base">
                    {t(item.q)}
                  </span>
                  <span className="flex w-6 h-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{t(item.a)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}